// extracted by mini-css-extract-plugin
export default {"container":"r5owzJ","title":"buaKbz","button":"Qlfkoo"};